"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'draft-groups/';
exports.default = {
  INIT: _DOMAIN + 'INIT',
  ADD: _DOMAIN + 'ADD',
  EDIT: _DOMAIN + 'EDIT',
  REMOVE_INIT: _DOMAIN + 'REMOVE_INIT',
  REMOVE_SUCCESS: _DOMAIN + 'REMOVE_SUCCESS',
  REMOVE_FAILURE: _DOMAIN + 'REMOVE_FAILURE',
  REMOVE_ERROR_DB_NOT_FOUND: _DOMAIN + 'REMOVE_ERROR_DB_NOT_FOUND',
  REMOVE_ERROR_DB_UNEXPECTED_ERROR: _DOMAIN + 'REMOVE_ERROR_DB_UNEXPECTED_ERROR'
};